import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../Dashboard/Dashboard.module.css';

const AnimatorDashboardStats = ({ stats }) => {
  if (!stats) return null;

  const items = [
    { label: 'RP animés en cours', value: stats.activeAnimatedThreads },
    { label: 'Mes RP animés', value: stats.myAnimatedThreads },
    { label: 'Posts animation (7j)', value: stats.animationPostsThisWeek, detail: `${stats.myAnimationPostsThisWeek ?? 0} par moi` },
    { label: 'Posts IA publiés', value: stats.aiAssistedPosts, detail: `${stats.myAiAssistedPosts ?? 0} par moi` },
    { label: 'PNJ d\'animation', value: stats.animationNpcs },
    { label: 'Events ouverts', value: stats.openRpActivities, link: '/rp-activities' },
  ];

  return (
    <div className={styles.statsGrid}>
      {items.map((item) => {
        const content = (
          <>
            <span className={styles.statValue}>{item.value}</span>
            <span className={styles.statLabel}>{item.label}</span>
            {item.detail && <span className={styles.statDetail}>{item.detail}</span>}
          </>
        );

        return item.link ? (
          <Link key={item.label} to={item.link} className={styles.statCard}>
            {content}
          </Link>
        ) : (
          <div key={item.label} className={styles.statCard}>
            {content}
          </div>
        );
      })}
    </div>
  );
};

export default AnimatorDashboardStats;
